export class AppSettings {
  public static API_ENDPOINT        = 'https://api-live.gharbaar.com/api/sell-prop/';
  public static API_ENDPOINT_AREA   = 'https://api-live.gharbaar.com/api/';
  public static API_ENDPOINT_IMG    = 'https://api-live.gharbaar.com/api/';
  public static TEMP_IMAGES         = 'https://api-live.gharbaar.com/uploads/temp/';

  // public static API_ENDPOINT        = 'http://192.168.18.67:8000/api/sell-prop/';
  // public static API_ENDPOINT_AREA   = 'http://192.168.18.67:8000/api/';
  // public static API_ENDPOINT_IMG    = 'http://192.168.18.67:8000/api/';
  // public static TEMP_IMAGES         = 'http://192.168.18.67:8000/uploads/temp/';

  public static PDF_ENDPOINT        = 'https://paymentplans.gharbaar.com/';
  public static PORTALS_ENDPOINT    = 'https://portal-backend.gharbaar.com/';
  public static leadSources         = ['UAN', 'Zameen', 'Facebook', 'Facebook-Web', 'Google-Web', 'Youtube-Web', 'Website'];
  public static leadInterest        = ['Shop', 'Luxury apartment', 'Food court Shop', 'Not sure yet'];
  public static leadStatus          = ['New Lead', 'In Contact', 'Call back', 'Not interested', 'Wrong No', 'Appointment', 'Rescheduled', 'No response', 'Uncertain', 'Duplicate', 'Visited', 'Sale'];
  public static AppointmentStatus   = ['Appointment', 'Rescheduled', 'No response', 'Call back', 'Visited', 'Sale', 'Not interested'];
  public static visitStatus         = ['Visited', 'Sale', 'PFSOE', 'Follow Up', 'Awaiting decision', 'Not interested', 'Uncertain'];
  public static realtorsStatus      = ['New Realtor', 'Briefing given', 'Signup Kit sent'];
  public static BinStatus           = ['New Lead', 'Call back', 'Not interested', 'Wrong No', 'Appointment', 'Rescheduled', 'Visited', 'Follow Up', 'No response', 'Uncertain', 'Duplicate', 'Sale'];
  public static projectClass          : any = {
    0: 'gharbaar-project',
    1: 'epark-project',
    2: 'sixthRoad',
    3: 'epark-project',
    4: 'tlr',
  };

  public static dataTableLang      : any = {
    "decimal":        "",
    "emptyTable":     "No data available in table",
    "info":           "Showing _START_ to _END_ of _TOTAL_ entries",
    "infoEmpty":      "Showing 0 to 0 of 0 entries",
    "infoFiltered":   "(filtered from _MAX_ total entries)",
    "infoPostFix":    "",
    "thousands":      ",",
    "lengthMenu":     "Results Per Page _MENU_",
    "loadingRecords": "Loading...",
    "processing":     "<div class='dt-loader'></div>",
    "search":         "Search:",
    "zeroRecords":    "No matching records found",
    "paginate": {
      "first":      "",
      "last":       "",
      "next":       ">",
      "previous":   "<"
    },
    "aria": {
      "sortAscending":  ": activate to sort column ascending",
      "sortDescending": ": activate to sort column descending"
    }
  }

  public static siteAbbr         : any = {
    'www.myperfectwords.com'                   : 'MPW',
    'www.myperfectpaper.net'                   : 'MPP',
    'www.sharkpapers.com'                      : 'SP',
    'www.docs.myperfectwords.com'              : 'MPW',
    'www.championpapers.com'                   : 'CP',
    'www.5staressays.com'                      : '5SE',
    'freeessaywriter.essaywritingforme.com'    : 'FEW',
    'www.essaywritingservice.college'          : 'EWS',
    'www.writemyessay.help'                    : 'WME',
    'www.essaywriter.college'                  : 'EWC',
    'www.collegeessay.org'                     : 'CE',
    'www.freeessaywriter.net'                  : 'FEW',
    'www.essaywritingforme.com'                : 'EWF',
    'www.beta.myperfectpaper.net'              : 'MPP',
    'www.topgradewriting.com'                  : 'TGW'
  };

  public static status      : any = [
    'New lead', 'In Contact', 'Wrong No', 'Call back', 'No Response', 'Uncertain', 'Duplicate'
  ]

  public static dispositionUnpaid      : any = [
    { 'name': 'New Lead',                   'value': 0 },
    { 'name': 'No Response',                'value': 1 },
    { 'name': 'In Contact',                 'value': 2 },
    { 'name': 'Not Interested',             'value': 3 },
    // { 'name': 'Order Closed',               'value': 4 },
    { 'name': 'Wrong Phone #',              'value': 5 },
    { 'name': 'Close with different order', 'value': 6 },
    { 'name': 'Close with different price', 'value': 7 },
    { 'name': 'Contact later',              'value': 8 }
  ];

  public static dispositionUnpaidAdmin : any = [
    { 'name': 'New Lead',                   'value': 0 },
    { 'name': 'No Response',                'value': 1 },
    { 'name': 'In Contact',                 'value': 2 },
    { 'name': 'Not Interested',             'value': 3 },
    { 'name': 'Order Closed',               'value': 4 },
    { 'name': 'Wrong Phone #',              'value': 5 },
    { 'name': 'Close with different order', 'value': 6 },
    { 'name': 'Close with different price', 'value': 7 },
    { 'name': 'Contact later',              'value': 8 }
  ]

  public static documentType      : any = [
    'Admission Essay','Analytical Essay','Annotated Bibliography','Application Letter','Brief Overview',
    'Argumentative Essay','Assessment','Assignment ','Biography','Book Reports','Book Reviews','Business Plan ',
    'Case Study ','College Paper','Coursework ','Cover Letter','Creative Writing ','Critical analysis','Critical Thinking ',
    'Dissertation ','eBooks ','Exposition Writing','Homework  ','Lab Report ','Literature Review ','Movie Review  ','News Release  ', 'Essay ',
    'Personal Statement ','Powerpoint Presentation (with speaker notes)','Powerpoint Presentation (without speaker notes)  ','Quiz  ','Reflection paper ',
    'Reflective Essay ','Report  ','Research Essay  ','Research Paper ','Research proposal ','Response Essay','Response paper  ','Scholarship Essay ','School Paper  ',
    'Speech','Term Paper  ','Thesis ','Thesis Proposal ','Other'
  ]

  public static searchTypes  = {
    Homes: [
      // Homes Types
      { name: 'House',              value: 'House',            plural: 'Houses',       pTypeSigular: 'Home', pTypePlural: 'Homes' },
      { name: 'Flat',               value: 'Flat',             plural: 'Flats'          },
      { name: 'Upper Portion',      value: 'Upper Portion',    plural: 'Upper Portions' },
      { name: 'Lower Portion',      value: 'Lower Portion',    plural: 'Lower Portions' },
      { name: 'Farm House',         value: 'Farm House',       plural: 'Farm Houses'    },
      { name: 'Room',               value: 'Room',             plural: 'Rooms'          },
      { name: 'Penthouse',          value: 'Penthouse',        plural: 'Penthouses'     },
    ],

    Plots: [
      // // Plot Types
      { name: 'Residential Plot',        value: 'Residential Plot',         plural: 'Residential Plots',       pTypeSigular: 'Plot', pTypePlural: 'Plots' },
      { name: 'Residential Plot File',   value: 'Residential Plot File',    plural: 'Residential Plot Files'         },
      { name: 'Residential Plot Form',   value: 'Residential Plot Form',    plural: 'Residential Plot Forms'         },

      { name: 'Commercial Plot',         value: 'Commercial Plot',          plural: 'Commercial Plots'               },
      { name: 'Commercial Plot File',    value: 'Commercial Plot File',     plural: 'Commercial Plot Files'          },
      { name: 'Commercial Plot Form',    value: 'Commercial Plot Form',     plural: 'Commercial Plot Forms'          },

      { name: 'Agricultural Land',       value: 'Agricultural Land',        plural: 'Agricultural Land'              },
      { name: 'Industrial Land',         value: 'Industrial Land',          plural: 'Industrial Land'                },
    ],

    Commercial: [
      // Commercial Types
      { name: 'Office',             value: 'Office',            plural: 'Offices', pTypeSigular: 'Commercial Property', pTypePlural: 'Commercial Properties' },
      { name: 'Shop',               value: 'Shop',              plural: 'Shops'       },
      { name: 'Warehouse',          value: 'Warehouse',         plural: 'Warehouses'  },
      { name: 'Factory',            value: 'Factory',           plural: 'Factories'   },
      { name: 'Building',           value: 'Building',          plural: 'Buildings'   },
      { name: 'Other',              value: 'Other',             plural: 'Other'       }
    ]
  };

  public static searchUnits  = [
    { unit: 'ftsq',  name: 'Ft²' },
    // { unit: 'yard',  name: 'Yd²' },
    // { unit: 'meter', name: 'M²' },
    { unit: 'marla', name: 'Marla' },
    { unit: 'kanal', name: 'Kanal' },
  ];

  public static cities  = [
    {"id": 11, "name" : "Islamabad"},
    {"id": 5,  "name" : "Rawalpindi"}
  ];

  public static maxPriceLabel = { name: 'Any', value: 100000000000 };
  public static writersRegion : any = ['NFW', 'Local', 'Foreigner', 'inhouse'];
  public static searchPrices    = [ 500000, 1000000, 2000000, 3500000, 5000000, 6500000, 8000000, 10000000, 12500000, 15000000,
    17500000, 20000000, 25000000, 30000000, 40000000, 50000000, 75000000, 100000000,
    250000000, 500000000, 1000000000, 5000000000
  ];
  public static searchAreas  = {
    ftsq  : [ 450, 675, 1125, 1800, 2250, 3375, 4500, 6750, 9000, 11250 ],
    yard  : [ 50, 60, 70, 80, 100, 120, 150, 200, 250, 300, 350, 400, 450, 500, 1000, 2000, 4000 ],
    meter : [ 50, 80, 130, 200, 250, 380, 510, 760, 1000, 1300, 1900, 2500, 3800, 5100, 6300, 13000, 19000, 25000, 51000 ],
    marla : [ 2, 3, 5, 8, 10, 15, 20, 30, 40, 50 ],
    kanal : [ 1, 2, 3, 4, 5, 6, 7, 8, 10, 12, 15, 20, 30, 50, 100 ]
  };
  // public static portalRegion  : any = [
  //                                       { value: 'NFW',                 name: 'NFW',                         onlyForProjectManager: false },
  //                                       { value: 'Local',               name: 'Local',                       onlyForProjectManager: false },
  //                                       { value: 'Foreigner',           name: 'Foreigner',                   onlyForProjectManager: false },
  //                                       { value: 'inhouse',             name: 'Inhouse',                     onlyForProjectManager: false },
  //                                       { value: 'wm-freelance',        name: 'WM-Freelance',                onlyForProjectManager: true },
  //                                       { value: 'admin',               name: 'Admin',                       onlyForProjectManager: true },
  //                                       { value: 'agent',               name: 'Agent',                       onlyForProjectManager: true },
  //                                       { value: 'sales',               name: 'Sales',                       onlyForProjectManager: true },
  //                                       { value: 'writer-manager',      name: 'Freelance Writer Manager',    onlyForProjectManager: true },
  //                                       { value: 'in-writer-manager',   name: 'In-House Writer Manager',     onlyForProjectManager: true },
  //                                       { value: 'project-manager',     name: 'Project Manager',             onlyForProjectManager: true },
  //                                       { value: 'quality-assurance',   name: 'Quality Assurance',           onlyForProjectManager: true },
  //                                       { value: 'it',                  name: 'IT',                          onlyForProjectManager: true },
  //                                       { value: 'hr',                  name: 'HR',                          onlyForProjectManager: true },
  //                                       { value: 'proofreader-manager', name: 'Proofreader Manager',         onlyForProjectManager: true },
  //                                       { value: 'proofreader',         name: 'Proofreader',                 onlyForProjectManager: true },
  //                                     ];

  public static noOfPages : any = [{label: "1 Page ~ 300 Words", value: 1}, { label: "2 Pages ~ 600 Words", value: 2}, { label: "3 Pages ~ 900 Words", value: 3}, { label: "4 Pages ~ 1200 Words", value: 4}, { label: "5 Pages ~ 1500 Words", value: 5}, { label: "6 Pages ~ 1800 Words", value: 6}, { label: "7 Pages ~ 2100 Words", value: 7}, { label: "8 Pages ~ 2400 Words", value: 8}, { label: "9 Pages ~ 2700 Words", value: 9}, { label: "10 Pages ~ 3000 Words", value: 10}, { label: "11 Pages ~ 3300 Words", value: 11}, { label: "12 Pages ~ 3600 Words", value: 12}, { label: "13 Pages ~ 3900 Words", value: 13}, { label: "14 Pages ~ 4200 Words", value: 14}, { label: "15 Pages ~ 4500 Words", value: 15}, { label: "16 Pages ~ 4800 Words", value: 16}, { label: "17 Pages ~ 5100 Words", value: 17}, { label: "18 Pages ~ 5400 Words", value: 18}, { label: "19 Pages ~ 5700 Words", value: 19}, { label: "20 Pages ~ 6000 Words", value: 20}, { label: "21 Pages ~ 6300 Words", value: 21}, { label: "22 Pages ~ 6600 Words", value: 22}, { label: "23 Pages ~ 6900 Words", value: 23}, { label: "24 Pages ~ 7200 Words", value: 24}, { label: "25 Pages ~ 7500 Words", value: 25}, { label: "26 Pages ~ 7800 Words", value: 26}, { label: "27 Pages ~ 8100 Words", value: 27}, { label: "28 Pages ~ 8400 Words", value: 28}, { label: "29 Pages ~ 8700 Words", value: 29}, { label: "30 Pages ~ 9000 Words", value: 30}, { label: "31 Pages ~ 9300 Words", value: 31}, { label: "32 Pages ~ 9600 Words", value: 32}, { label: "33 Pages ~ 9900 Words", value: 33}, { label: "34 Pages ~ 10200 Words", value: 34}, { label: "35 Pages ~ 10500 Words", value: 35}, { label: "36 Pages ~ 10800 Words", value: 36}, { label: "37 Pages ~ 11100 Words", value: 37}, { label: "38 Pages ~ 11400 Words", value: 38}, { label: "39 Pages ~ 11700 Words", value: 39}, { label: "40 Pages ~ 12000 Words", value: 40}, { label: "41 Pages ~ 12300 Words", value: 41}, { label: "42 Pages ~ 12600 Words", value: 42}, { label: "43 Pages ~ 12900 Words", value: 43}, { label: "44 Pages ~ 13200 Words", value: 44}, { label: "45 Pages ~ 13500 Words", value: 45}, { label: "46 Pages ~ 13800 Words", value: 46}, { label: "47 Pages ~ 14100 Words", value: 47}, { label: "48 Pages ~ 14400 Words", value: 48}, { label: "49 Pages ~ 14700 Words", value: 49}, { label: "50 Pages ~ 15000 Words", value: 50}, { label: "51 Pages ~ 15300 Words", value: 51}, { label: "52 Pages ~ 15600 Words", value: 52}, { label: "53 Pages ~ 15900 Words", value: 53}, { label: "54 Pages ~ 16200 Words", value: 54}, { label: "55 Pages ~ 16500 Words", value: 55}, { label: "56 Pages ~ 16800 Words", value: 56}, { label: "57 Pages ~ 17100 Words", value: 57}, { label: "58 Pages ~ 17400 Words", value: 58}, { label: "59 Pages ~ 17700 Words", value: 59}, { label: "60 Pages ~ 18000 Words", value: 60}, { label: "61 Pages ~ 18300 Words", value: 61}, { label: "62 Pages ~ 18600 Words", value: 62}, { label: "63 Pages ~ 18900 Words", value: 63}, { label: "64 Pages ~ 19200 Words", value: 64}, { label: "65 Pages ~ 19500 Words", value: 65}, { label: "66 Pages ~ 19800 Words", value: 66}, { label: "67 Pages ~ 20100 Words", value: 67}, { label: "68 Pages ~ 20400 Words", value: 68}, { label: "69 Pages ~ 20700 Words", value: 69}, { label: "70 Pages ~ 21000 Words", value: 70}, { label: "71 Pages ~ 21300 Words", value: 71}, { label: "72 Pages ~ 21600 Words", value: 72}, { label: "73 Pages ~ 21900 Words", value: 73}, { label: "74 Pages ~ 22200 Words", value: 74}, { label: "75 Pages ~ 22500 Words", value: 75}, { label: "76 Pages ~ 22800 Words", value: 76}, { label: "77 Pages ~ 23100 Words", value: 77}, { label: "78 Pages ~ 23400 Words", value: 78}, { label: "79 Pages ~ 23700 Words", value: 79}, { label: "80 Pages ~ 24000 Words", value: 80}, { label: "81 Pages ~ 24300 Words", value: 81}, { label: "82 Pages ~ 24600 Words", value: 82}, { label: "83 Pages ~ 24900 Words", value: 83}, { label: "84 Pages ~ 25200 Words", value: 84}, { label: "85 Pages ~ 25500 Words", value: 85}, { label: "86 Pages ~ 25800 Words", value: 86}, { label: "87 Pages ~ 26100 Words", value: 87}, { label: "88 Pages ~ 26400 Words", value: 88}, { label: "89 Pages ~ 26700 Words", value: 89}, { label: "90 Pages ~ 27000 Words", value: 90}, { label: "91 Pages ~ 27300 Words", value: 91}, { label: "92 Pages ~ 27600 Words", value: 92}, { label: "93 Pages ~ 27900 Words", value: 93}, { label: "94 Pages ~ 28200 Words", value: 94}, { label: "95 Pages ~ 28500 Words", value: 95}, { label: "96 Pages ~ 28800 Words", value: 96}, { label: "97 Pages ~ 29100 Words", value: 97}, { label: "98 Pages ~ 29400 Words", value: 98}, { label: "99 Pages ~ 29700 Words", value: 99}, { label: "100 Pages ~ 30000 Words", value: 100 }
]

public static agentShifts : any = [ 'morning', 'evening', 'night' ];

public static orderStatus : any =  [
  {name: 'New Order',           value: -1,   color:'validBox'},
  {name: 'Awaiting Feedback',   value: 1,    color:'validBox'},
  {name: 'In Process',          value: 2,    color:'validBox'},
  {name: 'Completed',           value: 3,    color:'validBox'},
  {name: 'Revision',            value: 4,    color:'validBox'},
  {name: 'Disputed',            value: 5,    color:'underReviewBox'},
  {name: 'CWHP',                value: 6,    color:'underReviewBox'},
  {name: 'Refunded',            value: 7,    color:'invalidBox'},
  {name: 'Credited',            value: 8,    color:'disabledBox'}
]

public static clientFeedback : any =  [
  { name: 'With +ve Feedback', value: 1 },
  { name: 'With -ve Feedback', value: 2 },
  { name: 'Without Feedback',  value: 0 }
]

public static validInvalidSales : any =  [
  { name: 'Valid',   value: 1, color: 'validBox'   },
  { name: 'Invalid', value: 0, color: 'invalidBox' }
]



}
